import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { Editor } from "@tiptap/react";
import { MdAddLink as AddLinkIcon } from "react-icons/md";
import { MdOutlineLinkOff as RemoveLinkIcon } from "react-icons/md";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { editorTrns } from "../trns";

interface Props {
  editor: Editor;
}

export const LinkButton: FC<Props> = ({ editor }) => {
  const { t } = useTranslation();
  const isActive = editor.isActive("link");

  const onLinkToggle = () => {
    const previousHref = editor.getAttributes("link").href;
    if (Boolean(previousHref)) {
      editor.chain().focus().extendMarkRange("link").unsetLink().run();
      return;
    }

    const href = window.prompt(t(editorTrns.linkPrompt));
    if (!href) return;
    editor.chain().focus().extendMarkRange("link").setLink({ href }).run();
  };

  const Icon = isActive ? RemoveLinkIcon : AddLinkIcon;

  return (
    <Button
      type="button"
      variant={ButtonVariants.SECONDARY}
      className="!rounded-md !duration-100 !p-1"
      onClick={onLinkToggle}
    >
      <Icon
        title="attach link"
        className={cn("w-5 h-5 text-black-base transition-colors duration-100")}
      />
    </Button>
  );
};
